export function filterFonotekaColumnIds(ids: string[], canReadFonoteka: boolean): string[] {
  if (canReadFonoteka) return ids;
  return ids.filter((id) => id !== 'has_music');
}
